import ArrowLeftURL, { ReactComponent as ArrowLeft } from "./arrowLeft.svg"
import ArrowRightURL, { ReactComponent as ArrowRight } from "./arrowRight.svg"
import BadgeURL, { ReactComponent as Badge } from "./Badge.svg"
import BendSquareURL, { ReactComponent as BendSquare } from "./BendSquare.svg"
import BoroSilicateGlassURL, { ReactComponent as BoroSilicateGlass } from "./borosilicate-glass.svg"
import BottleURL, { ReactComponent as Bottle } from "./Bottle.svg"
import BucketURL, { ReactComponent as Bucket } from "./Bucket.svg"
import CartURL, { ReactComponent as Cart } from "./Cart.svg"
import CartIconURL, { ReactComponent as CartIcon } from "./CartIcon.svg"
import CartOvalIconURL, { ReactComponent as CartOvalIcon } from "./CartOval.svg"
import CheckmarkCircleURL, { ReactComponent as CheckmarkCircle } from "./feather_check-circle.svg"
import CheckmarkCircleFullURL, { ReactComponent as CheckmarkCircleFull } from "./checkmarkFull.svg"
import CherryURL, { ReactComponent as Cherry } from "./cherry-outline-icon.svg"
import ClearURL, { ReactComponent as Clear } from "./Clear.svg"
import ClockURL, { ReactComponent as Clock } from "./Clock.svg"
import CloseURL, { ReactComponent as Close } from "./Close.svg"
import CottonURL, { ReactComponent as Cotton } from "./Cotton.svg"
import DosierungURL, { ReactComponent as Dosierung } from "./dosierung.svg"
import DotURL, { ReactComponent as Dot } from "./Dot.svg"
import WiderrufenURL, { ReactComponent as Widerrufen } from "./Widerrufen.svg"
import SendungsverfolgungURL, { ReactComponent as Sendungsverfolgung } from "./Sendungsverfolgung.svg"
import MoneyBackURL, { ReactComponent as MoneyBack } from "./MoneyBack.svg"
import KontaktURL, { ReactComponent as Kontakt } from "./Kontakt.svg"
import FAQURL, { ReactComponent as FAQ } from "./FAQ.svg"
import AboVerwaltungURL, { ReactComponent as AboVerwaltung } from "./AboVerwaltung.svg"
import DropURL, { ReactComponent as Drop } from "./drop.svg"
import DropdownURL, { ReactComponent as Dropdown } from "./Dropdown.svg"
// import EnvelopeURL, { ReactComponent as Envelope } from "./envelope.svg"
import EuroURL, { ReactComponent as Euro } from "./Euro.svg"
import FederURL, { ReactComponent as Feder } from "./federweich-icon.svg"
import FormulaURL, { ReactComponent as Formula } from "./formel.svg"
import GermanyURL, { ReactComponent as Germany } from "./Germany.svg"
import GlassURL, { ReactComponent as Glass } from "./glass.svg"
import GlassMaterialURL, { ReactComponent as GlassMaterial } from "./glass-icon.svg"
import HerbURL, { ReactComponent as Herb } from "./Herb.svg"
import InfoURL, { ReactComponent as Info } from "./Info.svg"
import InstagramURL, { ReactComponent as Instagram } from "./InstagramIcon.svg"
import KapselInKapselURL, { ReactComponent as KapselInKapsel } from "./kapsel-in-kapsel.svg"
import LichtabschirmungURL, {
  ReactComponent as Lichtabschirmung,
} from "./lichtabschirmung-icon.svg"
import LieferzeitURL, { ReactComponent as Lieferzeit } from "./Lieferzeit.svg"
// import LiveChatURL, { ReactComponent as LiveChat } from "./LiveChat.svg"
import { BsChatDots } from "react-icons/bs"
import LockURL, { ReactComponent as Lock } from "./Lock.svg"
import MaskeURL, { ReactComponent as Maske } from "./mask-icon.svg"
import MenuURL, { ReactComponent as Menu } from "./Menu.svg"
import MintURL, { ReactComponent as Mint } from "./minze.svg"
import MobileMenuIconURL, { ReactComponent as MobileMenuIcon } from "./MobileMenuIcon.svg"
import MoonURL, { ReactComponent as Moon } from "./Moon.svg"
import MushroomURL, { ReactComponent as Mushroom } from "./mushroom.svg"
import NewsLetterIconURL, { ReactComponent as NewsLetterIcon } from "./NewsLetterIcon.svg"
import PackageURL, { ReactComponent as Package } from "./Package.svg"
import PlaneURL, { ReactComponent as Plane } from "./Plane.svg"
import QuotationMarkURL, { ReactComponent as QuotationMark } from "./QuotationMark.svg"
import ReturnURL, { ReactComponent as Return } from "./Return.svg"
import RosmarinURL, { ReactComponent as Rosmarin } from "./rosmarin-icon.svg"
import SavingsURL, { ReactComponent as Savings } from "./Savings.svg"
// import SleepInkIconURL, { ReactComponent as SleepInkIcon } from "./SleepInkIcon.svg"
// import SmartphoneURL, { ReactComponent as Smartphone } from
// "./Smartphone.svg"
import { FiPhone, FiMail } from "react-icons/fi"
import StarBlackURL, { ReactComponent as StarBlack } from "./StarBlack.svg"
import SundownURL, { ReactComponent as Sundown } from "./Sundown.svg"
import SustainableURL, { ReactComponent as Sustainable } from "./sustainable.svg"
// import TrashURL, { ReactComponent as Trash } from "./Trash.svg"
import TripuraURL, { ReactComponent as Tripura } from "./tripura.svg"
import VeganURL, { ReactComponent as Vegan } from "./vegan.svg"
import WaschmaschineURL, { ReactComponent as Waschmaschine } from "./wash-machine.svg"
// import WhatsAppURL, { ReactComponent as WhatsApp } from "./WhatsApp.svg"
import ZZZURL, { ReactComponent as ZZZ } from "./ZZZ.svg"
import ZweiPhasenURL, { ReactComponent as ZweiPhasen } from "./2-phasen-wirkung.svg"
import { MdPerson, MdStar, MdCheck } from "react-icons/md"
import { FaSpinner, FaWhatsapp } from "react-icons/fa"
import { HiOutlineTrash } from "react-icons/hi"

const componentMap = {
  Widerrufen,
  Sendungsverfolgung,
  MoneyBack,
  Kontakt,
  FAQ,
  AboVerwaltung,
  ArrowLeft,
  ArrowRight,
  Badge,
  BendSquare,
  BoroSilicateGlass,
  Bottle,
  Bucket,
  Cart,
  CartIcon,
  CartOvalIcon,
  Check: MdCheck,
  CheckmarkCircle,
  CheckmarkCircleFull,
  Cherry,
  Clear,
  Clock,
  Close,
  Cotton,
  Dosierung,
  Dot,
  Drop,
  Dropdown,
  Envelope: FiMail,
  Euro,
  Feder,
  Formula,
  Germany,
  Glass,
  GlassMaterial,
  Herb,
  Info,
  Instagram,
  KapselInKapsel,
  Lichtabschirmung,
  Lieferzeit,
  LiveChat: BsChatDots,
  Lock,
  Maske,
  Menu,
  Mint,
  MobileMenuIcon,
  Moon,
  Mushroom,
  NewsLetterIcon,
  Package,
  Person: MdPerson,
  Plane,
  QuotationMark,
  Return,
  Rosmarin,
  Savings,
  // SleepInkIcon,
  Smartphone: FiPhone,
  Spinner: FaSpinner,
  Star: MdStar,
  StarBlack,
  Sundown,
  Sustainable,
  Trash: HiOutlineTrash,
  Tripura,
  Vegan,
  Waschmaschine,
  WhatsApp: FaWhatsapp,
  ZweiPhasen,
  ZZZ,
}

const urlMap = {
  Widerrufen: WiderrufenURL,
  Sendungsverfolgung: SendungsverfolgungURL,
  MoneyBack: MoneyBackURL,
  Kontakt: KontaktURL,
  FAQ: FAQURL,
  AboVerwaltung: AboVerwaltungURL,
  ArrowLeft: ArrowLeftURL,
  ArrowRight: ArrowRightURL,
  Badge: BadgeURL,
  BendSquare: BendSquareURL,
  BoroSilicateGlass: BoroSilicateGlassURL,
  Bottle: BottleURL,
  Bucket: BucketURL,
  Cart: CartURL,
  CartIcon: CartIconURL,
  CartOvalIcon: CartOvalIconURL,
  Check: DotURL,
  CheckmarkCircle: CheckmarkCircleURL,
  CheckmarkCircleFull: CheckmarkCircleFullURL,
  Cherry: CherryURL,
  Clear: ClearURL,
  Clock: ClockURL,
  Close: CloseURL,
  Cotton: CottonURL,
  Dosierung: DosierungURL,
  Dot: DotURL,
  Drop: DropURL,
  Dropdown: DropdownURL,
  Envelope: DotURL,
  Euro: EuroURL,
  Feder: FederURL,
  Formula: FormulaURL,
  Germany: GermanyURL,
  Glass: GlassURL,
  GlassMaterial: GlassMaterialURL,
  Herb: HerbURL,
  Info: InfoURL,
  Instagram: InstagramURL,
  KapselInKapsel: KapselInKapselURL,
  Lichtabschirmung: LichtabschirmungURL,
  Lieferzeit: LieferzeitURL,
  LiveChat: DotURL,
  Lock: LockURL,
  Maske: MaskeURL,
  Menu: MenuURL,
  Mint: MintURL,
  MobileMenuIcon: MobileMenuIconURL,
  Moon: MoonURL,
  Mushroom: MushroomURL,
  NewsLetterIcon: NewsLetterIconURL,
  Package: PackageURL,
  Person: DotURL,
  Plane: PlaneURL,
  QuotationMark: QuotationMarkURL,
  Return: ReturnURL,
  Rosmarin: RosmarinURL,
  Savings: SavingsURL,
  // SleepInkIcon: SleepInkIconURL,
  Smartphone: DotURL,
  Spinner: DotURL,
  Star: DotURL,
  StarBlack: StarBlackURL,
  Sundown: SundownURL,
  Sustainable: SustainableURL,
  Trash: DotURL,
  Tripura: TripuraURL,
  Vegan: VeganURL,
  Waschmaschine: WaschmaschineURL,
  WhatsApp: DotURL,
  ZweiPhasen: ZweiPhasenURL,
  ZZZ: ZZZURL,
}

export { componentMap, urlMap }
